import { useEffect, useRef, useState } from "react";
import {
  FaHeart,
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt,
  FaGift,
  FaVolumeUp,
  FaVolumeMute,
} from "react-icons/fa";
import { GiQueenCrown, GiCastle, GiSparkles } from "react-icons/gi";
import { BsStars } from "react-icons/bs";
import { Helmet } from "react-helmet-async";
import "./HeilyInvitation.css";

import mainPhoto from "../img/cumpleH/keyconhey.webp";

import collage1 from "../img/cumpleH/collage1.webp";
import collage2 from "../img/cumpleH/collage2.webp";
import collage3 from "../img/cumpleH/collage3.webp";
import collage4 from "../img/cumpleH/collage4.webp";
import collage5 from "../img/cumpleH/collage5.webp";
import collage6 from "../img/cumpleH/collage6.webp";
import collage7 from "../img/cumpleH/collage7.webp";
import collage8 from "../img/cumpleH/collage8.webp";
import collage9 from "../img/cumpleH/collage9.webp";
import collage10 from "../img/cumpleH/collage10.webp";

import birthdaySong from "../audio/cancion2.mp3";

const collagePhotos = [
  collage1,
  collage2,
  collage3,
  collage4,
  collage5,
  collage6,
  collage7,
  collage8,
  collage9,
  collage10,
];

const eventAddress = "21374 NW 40th Circle Ct, Miami, Florida 33055";

const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  eventAddress
)}`;

function HeilyInvitation() {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showMusicButton, setShowMusicButton] = useState(false);

  const playMusic = async () => {
    if (!audioRef.current) return;

    try {
      audioRef.current.volume = 0.35;
      await audioRef.current.play();
      setIsPlaying(true);
      setShowMusicButton(false);
    } catch (error) {
      setIsPlaying(false);
      setShowMusicButton(true);
      console.log("La reproducción automática fue bloqueada:", error);
    }
  };

  const pauseMusic = () => {
    if (!audioRef.current) return;

    audioRef.current.pause();
    setIsPlaying(false);
    setShowMusicButton(true);
  };

  const toggleMusic = (event) => {
    event.stopPropagation();

    if (isPlaying) {
      pauseMusic();
    } else {
      playMusic();
    }
  };

  useEffect(() => {
    playMusic();
  }, []);

  return (
    <main
      className="royal-page"
      onClick={!isPlaying ? playMusic : undefined}
    >
      <Helmet>
        <title>2.º Cumpleaños de Heily</title>

        <meta
          name="description"
          content="Estás invitado al 2.º cumpleaños de Heily. Dos años llenos de amor, magia y aventuras."
        />

        <meta property="og:title" content="2.º Cumpleaños de Heily" />
        <meta
          property="og:description"
          content="Estás invitado al 2.º cumpleaños de Heily. Dos años llenos de amor y aventuras."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://charmieskastle.com/cumpleheily"
        />
        <meta
          property="og:image"
          content="https://charmieskastle.com/heily-preview.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="2.º Cumpleaños de Heily" />
        <meta
          name="twitter:description"
          content="Estás invitado al 2.º cumpleaños de Heily."
        />
        <meta
          name="twitter:image"
          content="https://charmieskastle.com/heily-preview.png"
        />
      </Helmet>

      <audio
        ref={audioRef}
        src={birthdaySong}
        loop
        autoPlay
        preload="auto"
        playsInline
        onTimeUpdate={() => {
          if (audioRef.current && audioRef.current.currentTime >= 30
          ) {
            audioRef.current.currentTime = 0;
            audioRef.current.play();
          }
        }}
      />

      {showMusicButton && (
        <button className="heily-music-btn" type="button" onClick={toggleMusic}>
          {isPlaying ? <FaVolumeUp /> : <FaVolumeMute />}
          <span>{isPlaying ? "Música activa" : "Reproducir música"}</span>
        </button>
      )}

      <section className="royal-card">
        <div className="royal-bg-decor" aria-hidden="true">
          <span className="royal-decor decor-1">
            <GiQueenCrown />
          </span>
          <span className="royal-decor decor-2">
            <BsStars />
          </span>
          <span className="royal-decor decor-3">
            <FaHeart />
          </span>
          <span className="royal-decor decor-4">
            <GiSparkles />
          </span>
          <span className="royal-decor decor-5">
            <GiQueenCrown />
          </span>
          <span className="royal-decor decor-6">
            <BsStars />
          </span>
        </div>

        <div className="royal-header-strip">
          <span></span>
          <div>
            <GiCastle />
            <p>Una celebración de cuento</p>
          </div>
          <span></span>
        </div>

        <section className="royal-hero">
          <div className="hero-copy">
            <p className="royal-kicker">Estás invitado al</p>

            <h1>
              2.º Cumpleaños
              <small>de</small>
              <strong>Heily</strong>
            </h1>

            <p className="royal-subtitle">
              Dos años llenos de amor, dulzura y aventuras.
            </p>

            <div className="royal-message-box">
              <GiQueenCrown />
              <p>
                Una tarde especial para celebrar a nuestra pequeña, rodeada de
                cariño, sonrisas y momentos inolvidables.
              </p>
            </div>
          </div>

          <div className="royal-photo-wrap">
            <div className="royal-photo-glow"></div>

            <div className="royal-photo-frame">
              <div className="crown-badge">
                <GiQueenCrown />
              </div>

              <img src={mainPhoto} alt="Heily" />

              <div className="photo-nameplate">
                <span>Heily</span>
              </div>
            </div>
          </div>
        </section>

        <section className="royal-note-section">
          <div className="royal-note-card">
            <div className="note-icon">
              <FaGift />
            </div>

            <div>
              <span>Un mensajito especial</span>
              <p>
                Me haría muy feliz contar con tu presencia. Si deseas tener un
                detalle con mi princesa, cualquier regalo será bienvenido y muy
                apreciado.
              </p>
            </div>
          </div>
        </section>

        <section className="royal-event-section">
          <article className="royal-event-card">
            <div className="event-icon">
              <FaCalendarAlt />
            </div>

            <div>
              <span>Fecha</span>
              <strong>Domingo 2 de agosto</strong>
            </div>
          </article>

          <article className="royal-event-card">
            <div className="event-icon">
              <FaClock />
            </div>

            <div>
              <span>Hora</span>
              <strong>6:30 PM</strong>
            </div>
          </article>

          <article className="royal-event-card royal-location-card">
            <div className="event-icon">
              <FaMapMarkerAlt />
            </div>

            <div>
              <span>Lugar</span>
              <strong>Casa de Heily</strong>

              <a
                className="royal-map-button"
                href={googleMapsUrl}
                target="_blank"
                rel="noreferrer"
                onClick={(event) => event.stopPropagation()}
              >
                Presiona aquí para obtener la dirección
              </a>
            </div>
          </article>
        </section>

        <section className="royal-memories-section">
          <div className="memories-title-block">
            <div className="title-ornament">
              <span></span>
              <GiQueenCrown />
              <span></span>
            </div>

            <p>Pequeños recuerdos</p>
            <h2>Momentos mágicos de Heily</h2>
            <h3>Dos años llenos de amor y aventuras</h3>
          </div>

          <div className="royal-album">
            {collagePhotos.map((photo, index) => (
              <article
                className={`album-photo album-photo-${index + 1}`}
                key={`heily-memory-${index + 1}`}
              >
                <img src={photo} alt={`Recuerdo ${index + 1} de Heily`} />

                <div className="album-shine"></div>

                <span className="album-pin">
                  <GiSparkles />
                </span>
              </article>
            ))}
          </div>
        </section>

        <footer className="royal-footer">
          <span></span>
          <p>Con cariño, Keili y Heily</p>
          <span></span>
        </footer>
      </section>
    </main>
  );
}

export default HeilyInvitation;